import React, { useState } from "react";
import { LogOut, Pencil, Eye, Network, BarChart3, History, LogIn } from "lucide-react";
import UserAvatar from "./UserAvatar";
import ThemeSwitcher from "../ThemeSwitcher";
import ExportMenu from "./ExportMenu";
import AccountSettings from "./AccountSettings";
import { useTheme } from "../ThemeProvider";
import { useAuth } from "@/lib/AuthContext";
import { startAuthorization } from "@/services/auth";


export default function TopBar({ isAdmin, editMode, onToggleEdit, onLogout, exportRef, onStats, onAuditLog, onHierarchy, nodes }) {
  const { theme } = useTheme();
  const { user } = useAuth();
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleLogin = () => {
    // Start the Blocks IAM (OIDC) login flow.
    startAuthorization();
  };

  return (
    <header className="bg-white/70 dark:bg-slate-900/50 backdrop-blur-xl border-b border-gray-200/60 dark:border-transparent sticky top-0 z-40" style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
      <div className="max-w-[1800px] mx-auto px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src="https://media.base44.com/images/public/6a3e1c26ec9e714e5b52016b/70232ae49_SELISE_Logo_1.svg"
            alt="SELISE Group"
            className="h-10 w-auto"
            style={theme === "dark" ? { filter: "drop-shadow(0 0 12px rgba(255,255,255,0.5))" } : undefined}
          />
        </div>
        <div className="flex items-center gap-2">
          <ThemeSwitcher />
          <ExportMenu targetRef={exportRef} nodes={nodes} />
          <button
            onClick={onStats}
            title="Org Stats"
            className="p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <BarChart3 className="w-4 h-4" />
          </button>
          {isAdmin && (
            <button
              onClick={onAuditLog}
              title="Change History"
              className="p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <History className="w-4 h-4" />
            </button>
          )}
          <button
            onClick={onHierarchy}
            title="View Executive Hierarchy"
            className="p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <Network className="w-4 h-4" />
          </button>
          {isAdmin && (
            <button
              onClick={onToggleEdit}
              title={editMode ? "Editing" : "Edit"}
              className={`p-2 rounded-lg transition-colors ${
                editMode
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              {editMode ? <Pencil className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          )}
          {user ? (
            <button
              onClick={onLogout}
              title="Logout"
              className="p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <LogOut className="w-4 h-4" />
            </button>
          ) : (
            <button
              onClick={handleLogin}
              title="Login"
              className="p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <LogIn className="w-4 h-4" />
            </button>
          )}
          {user && (
            <button
              onClick={() => setSettingsOpen(true)}
              title="Account settings"
              className="rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500/50"
            >
              <UserAvatar user={user} size="sm" />
            </button>
          )}
        </div>
      </div>
      {user && <AccountSettings open={settingsOpen} onOpenChange={setSettingsOpen} />}
    </header>
  );
}